import { render, staticRenderFns } from "./DraggableItem.vue?vue&type=template&id=585ab6f8&scoped=true"
import script from "./DraggableItem.vue?vue&type=script&lang=ts"
export * from "./DraggableItem.vue?vue&type=script&lang=ts"
import style0 from "./DraggableItem.vue?vue&type=style&index=0&id=585ab6f8&prod&lang=scss"
import style1 from "./DraggableItem.vue?vue&type=style&index=1&id=585ab6f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ab6f8",
  null
  
)

export default component.exports